import { api } from './authService';

// 获取当前租户的API基础路径
function getApiBase(): string {
  const tenantCode = localStorage.getItem('currentTenant') || 'default';
  return `/${tenantCode}`;
}

// 获取服务API基础路径
function getServicesApiBase(): string {
  return '';
}

export interface Server {
  id: number;
  tenant_code: string;
  server_name: string;
  server_url: string;
  auth_type: string;
  username?: string;
  password?: string;
  api_key?: string;
  bearer_token?: string;
  client_id?: string;
  client_secret?: string;
  oauth2_token_url?: string;
  additional_headers?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateServerRequest {
  tenant_code: string;
  server_name: string;
  server_url: string;
  auth_type: string;
  username?: string;
  password?: string;
  api_key?: string;
  bearer_token?: string;
  client_id?: string;
  client_secret?: string;
  oauth2_token_url?: string;
  additional_headers?: string;
  is_active: boolean;
}

export interface UpdateServerRequest {
  server_name?: string;
  server_url?: string;
  auth_type?: string;
  username?: string;
  password?: string;
  api_key?: string;
  bearer_token?: string;
  client_id?: string;
  client_secret?: string;
  oauth2_token_url?: string;
  additional_headers?: string;
  is_active?: boolean;
}

export interface TestConnectionResult {
  success: boolean;
  message?: string;
  error?: string;
  response_time?: number;
}

// ==================== 统一服务管理类型定义 ====================

export interface Service {
  id?: number;
  tenant_code: string;
  project_id?: string | number | null;
  service_name: string;
  service_type: 'ai_platform' | 'webhook' | 'api' | 'proxied_ai_platform' | 'database' | 'custom';
  service_url: string;
  description?: string;
  auth_type: 'api_key' | 'oauth2' | 'bearer' | 'basic' | 'app_key';
  api_key?: string;
  x_app_id?: string | null;
  x_app_key?: string | null;
  client_id?: string;
  client_secret?: string;
  oauth2_token_url?: string;
  oauth2_scope?: string;
  oauth2_redirect_uri?: string;
  username?: string;
  password?: string;
  bearer_token?: string;
  additional_headers?: string;
  timeout_seconds?: number;
  retry_count?: number;
  platform_type?: 'openai' | 'claude' | 'dify' | 'ibuild' | 'custom';
  app_name?: string;
  app_id?: string;
  home_page_link?: string;
  health_link?: string;
  is_active: boolean;
  is_file_storage_provider?: boolean;
  last_health_check?: string;
  health_status?: 'healthy' | 'unhealthy' | 'unknown';
  created_at?: string;
  updated_at?: string;
}


export interface CreateServiceRequest {
  tenant_code: string;
  project_id?: string | number | null;
  service_name: string;
  service_type: 'ai_platform' | 'webhook' | 'api' | 'proxied_ai_platform' | 'database' | 'custom';
  service_url: string;
  description?: string;
  auth_type: 'api_key' | 'oauth2' | 'bearer' | 'basic' | 'app_key';
  api_key?: string;
  x_app_id?: string | null;
  x_app_key?: string | null;
  client_id?: string;
  client_secret?: string;
  oauth2_token_url?: string;
  oauth2_scope?: string;
  oauth2_redirect_uri?: string;
  username?: string;
  password?: string;
  bearer_token?: string;
  additional_headers?: string;
  timeout_seconds?: number;
  retry_count?: number;
  platform_type?: 'openai' | 'claude' | 'dify' | 'ibuild' | 'custom';
  app_name?: string;
  app_id?: string;
  home_page_link?: string;
  health_link?: string;
  is_active?: boolean;
  is_file_storage_provider?: boolean;
}

export interface UpdateServiceRequest {
  project_id?: string | number | null;
  service_name?: string;
  service_type?: 'ai_platform' | 'webhook' | 'api' | 'proxied_ai_platform' | 'database' | 'custom';
  service_url?: string;
  description?: string;
  auth_type?: 'api_key' | 'oauth2' | 'bearer' | 'basic' | 'app_key';
  api_key?: string;
  x_app_id?: string | null;
  x_app_key?: string | null;
  client_id?: string;
  client_secret?: string;
  oauth2_token_url?: string;
  oauth2_scope?: string;
  oauth2_redirect_uri?: string;
  username?: string;
  password?: string;
  bearer_token?: string;
  additional_headers?: string;
  timeout_seconds?: number;
  retry_count?: number;
  platform_type?: 'openai' | 'claude' | 'dify' | 'ibuild' | 'custom';
  app_name?: string;
  app_id?: string;
  home_page_link?: string;
  health_link?: string;
  is_active?: boolean;
  is_file_storage_provider?: boolean;
}


export interface ServiceQuery {
  tenant_code: string;
  service_type?: 'ai_platform' | 'webhook' | 'api' | 'proxied_ai_platform' | 'database' | 'custom';
  platform_type?: 'openai' | 'claude' | 'dify' | 'ibuild' | 'custom';
  auth_type?: 'api_key' | 'oauth2' | 'bearer' | 'basic' | 'app_key';
  is_active?: boolean;
  limit?: number;
  offset?: number;
}


export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  total?: number;
  message?: string;
  error?: string;
}

export const serverService = {
  async getServiceNameOptions(): Promise<string[]> {
    const tenantCode = localStorage.getItem('currentTenant') || 'default';
    const response = await api.get(`${getServicesApiBase()}/${tenantCode}/services/name-options`);
    return response.data.data || [];
  },
  // 获取所有服务器配置
  async getServers(): Promise<{ servers: Server[]; total: number }> {
    const response = await api.get(`${getApiBase()}/servers`);
    return response.data;
  },

  // 根据ID获取服务器配置
  async getServer(id: number): Promise<Server> {
    const response = await api.get(`${getApiBase()}/servers/${id}`);
    return response.data.server;
  },

  // 根据租户代码获取服务器配置
  async getServerByTenantCode(tenantCode: string, serverName?: string): Promise<Server> {
    const url = serverName 
      ? `${getApiBase()}/servers/tenant/${tenantCode}/${serverName}`
      : `${getApiBase()}/servers/tenant/${tenantCode}`;
    const response = await api.get(url);
    return response.data.server;
  },

  // 创建服务器配置
  async createServer(data: CreateServerRequest): Promise<Server> {
    const response = await api.post(`${getApiBase()}/servers`, data);
    return response.data.server;
  },

  // 更新服务器配置
  async updateServer(id: number, data: UpdateServerRequest): Promise<Server> {
    const response = await api.put(`${getApiBase()}/servers/${id}`, data);
    return response.data.server;
  },

  // 删除服务器配置
  async deleteServer(id: number): Promise<void> {
    await api.delete(`${getApiBase()}/servers/${id}`);
  },

  // 测试服务器连接
  async testConnection(id: number): Promise<TestConnectionResult> {
    const response = await api.post(`${getApiBase()}/servers/${id}/test`);
    return response.data;
  },

  // ==================== 服务管理 API ====================

  // 获取服务列表
  async getServices(query: ServiceQuery): Promise<ApiResponse<Service[]>> {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    const response = await api.get(`${getServicesApiBase()}/${query.tenant_code}/services?${params.toString()}`);
    return response.data;
  },

  // 创建服务
  async createService(request: CreateServiceRequest): Promise<ApiResponse<{ id: number }>> {
    const response = await api.post(`${getServicesApiBase()}/${request.tenant_code}/services`, request);
    return response.data;
  },

  // 更新服务
  async updateService(id: number, request: UpdateServiceRequest): Promise<ApiResponse<void>> {
    const tenantCode = localStorage.getItem('currentTenant') || 'default';
    const response = await api.put(`${getServicesApiBase()}/${tenantCode}/services/${id}`, request);
    return response.data;
  },

  // 删除服务
  async deleteService(id: number): Promise<ApiResponse<void>> {
    const tenantCode = localStorage.getItem('currentTenant') || 'default';
    const response = await api.delete(`${getServicesApiBase()}/${tenantCode}/services/${id}`);
    return response.data;
  },

  // 执行服务健康检查
  async performHealthCheck(serviceId: number): Promise<ApiResponse<unknown>> {
    const tenantCode = localStorage.getItem('currentTenant') || 'default';
    const response = await api.post(`${getServicesApiBase()}/${tenantCode}/services/health-check/${serviceId}`);
    return response.data;
  },

};
